import { AuthState, useFirebaseAuth } from 'hooks/useFirebaseAuth';
import useSWR from 'swr';
import { getUserAndWorkshopRelation } from './workshopApi';

interface UseUserAndWorkshopRelationArguments {
  workshopId: string;
}

const useUserAndWorkshopRelation = ({
  workshopId
}: UseUserAndWorkshopRelationArguments) => {
  const { authState, user } = useFirebaseAuth();
  const isUserAuthenticated = authState === AuthState.AUTHORIZED;
  const loggedInUserId = user?.uid ?? '';
  const isRequireDetailsAvailable = !!(
    isUserAuthenticated &&
    loggedInUserId &&
    workshopId
  );

  const { data, error, isValidating, revalidate } = useSWR(
    isRequireDetailsAvailable
      ? `user/${loggedInUserId}/relation/workshop/${workshopId}`
      : null,
    () => {
      if (!isRequireDetailsAvailable) {
        return null;
      }

      return getUserAndWorkshopRelation({ userId: loggedInUserId, workshopId });
    },
    {
      revalidateOnMount: true
    }
  );

  const isFetchingDetails = isRequireDetailsAvailable && !data && isValidating;

  return {
    isFetchingUserWorkshopRelation: isFetchingDetails,
    userAndWorkshopRelation: data,
    userWorkshopRelationError: error,
    isUserAuthenticated,
    revalidateUserWorkshopRelation: revalidate
  };
};

export default useUserAndWorkshopRelation;
